
(() => {
  const root = document.getElementById('oy-rental-first-piece');
  if (!root) return;
  const logoTrack = root.querySelector('.oy-logo-track');
  const duplicateLogos = logoTrack.firstElementChild.cloneNode(true);
  duplicateLogos.classList.add('oy-logo-duplicate');
  duplicateLogos.setAttribute('aria-hidden', 'true');
  duplicateLogos.querySelectorAll('img').forEach(img => { img.alt = ''; });
  logoTrack.appendChild(duplicateLogos);
  const productMedia = JSON.parse(document.getElementById('oy-rental-product-media').textContent);
  const productImage = root.querySelector('.oy-product-image');
  const productCaption = root.querySelector('.oy-product-caption');
  const thumbnails = root.querySelector('.oy-thumbnails');
  const previousPhoto = root.querySelector('.oy-gallery-prev');
  const nextPhoto = root.querySelector('.oy-gallery-next');
  let productIndex = 0;
  const thumbnailButtons = productMedia.map((item, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'oy-thumbnail cursor-interaction';
    button.setAttribute('aria-label', `${root.dataset.photoLabel} ${index + 1}: ${item.label}`);
    const img = document.createElement('img');
    const thumbnailUrl = new URL(item.src, window.location.href);
    thumbnailUrl.searchParams.set('width', '144');
    img.src = thumbnailUrl.href;
    img.alt = '';
    img.loading = 'lazy';
    button.appendChild(img);
    button.addEventListener('click', () => showProductImage(index));
    thumbnails.appendChild(button);
    return button;
  });
  function showProductImage(index) {
    productIndex = Math.max(0, Math.min(productMedia.length - 1, index));
    const item = productMedia[productIndex];
    productImage.src = item.src;
    productImage.alt = item.caption;
    productCaption.textContent = item.caption;
    previousPhoto.hidden = productIndex === 0;
    nextPhoto.hidden = productIndex === productMedia.length - 1;
    const firstThumbnail = Math.floor(productIndex / 6) * 6;
    thumbnailButtons.forEach((button, i) => {
      button.setAttribute('aria-current', String(i === productIndex));
      button.hidden = i < firstThumbnail || i >= firstThumbnail + 6;
    });
  }
  previousPhoto.addEventListener('click', () => showProductImage(productIndex - 1));
  nextPhoto.addEventListener('click', () => showProductImage(productIndex + 1));
  showProductImage(0);
  const productTabs = [...root.querySelectorAll('.oy-product-tab')];
  function selectProductTab(index) {
    productTabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      document.getElementById(tab.getAttribute('aria-controls')).hidden = i !== index;
    });
  }
  productTabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectProductTab(index));
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? productTabs.length - 1
        : (index + (event.key === 'ArrowRight' ? 1 : -1) + productTabs.length) % productTabs.length;
      selectProductTab(next);
      productTabs[next].focus();
    });
  });
  const slides = [...root.querySelectorAll('.oy-background')];
  const video = root.querySelector('.oy-video');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let inView = true;
  let current = 0;
  let generation = 0;
  let timer;
  let cleanupTimer;
  let prepareTimer;
  const canRun = () => !reducedMotion.matches && inView && !document.hidden;

  function prepare(slide) {
    if (!slide.dataset.src) return;
    if (slide.dataset.srcset) slide.srcset = slide.dataset.srcset;
    slide.src = slide.dataset.src;
    delete slide.dataset.src;
    if (slide.dataset.poster) {
      const poster = new URL(slide.dataset.poster, window.location.href);
      poster.searchParams.set('width', String(Math.min(1280, Math.ceil(window.innerWidth * window.devicePixelRatio))));
      slide.poster = poster.href;
      delete slide.dataset.poster;
    }
  }

  function schedule() {
    clearTimeout(timer);
    clearTimeout(prepareTimer);
    if (!canRun()) return;
    const delay = slides[current] === video
      ? Math.max(1000, ((video.duration || 5) - video.currentTime) * 1000 + 250)
      : 6000;
    timer = setTimeout(advance, delay);
    const upcoming = slides[(current + 1) % slides.length];
    if (upcoming !== video) prepareTimer = setTimeout(() => prepare(upcoming), Math.max(0, delay - 2000));
  }

  function activate(next) {
    clearTimeout(cleanupTimer);
    slides.forEach(slide => slide.classList.remove('oy-outgoing'));
    const previous = slides[current];
    previous.classList.add('oy-outgoing');
    previous.classList.remove('oy-active');
    slides[next].classList.add('oy-active');
    current = next;
    if (slides[current] !== video) video.pause();
    cleanupTimer = setTimeout(() => previous.classList.remove('oy-outgoing'), 1250);
    schedule();
  }

  function advance() {
    clearTimeout(timer);
    if (!canRun()) return;
    const next = (current + 1) % slides.length;
    const token = ++generation;
    prepare(slides[next]);
    if (slides[next] !== video) {
      slides[next].decode().catch(() => {}).then(() => {
        if (token === generation && canRun()) activate(next);
      });
      return;
    }
    video.muted = true;
    video.currentTime = 0;
    const skipVideo = () => {
      if (token !== generation || !canRun()) return;
      ++generation;
      clearTimeout(timer);
      video.pause();
      const fallback = (next + 1) % slides.length;
      prepare(slides[fallback]);
      const fallbackToken = generation;
      slides[fallback].decode().catch(() => {}).then(() => {
        if (fallbackToken === generation && canRun()) activate(fallback);
      });
    };
    timer = setTimeout(skipVideo, 3000);
    video.play().then(() => {
      if (token !== generation || !canRun()) { video.pause(); return; }
      clearTimeout(timer);
      activate(next);
    }).catch(skipVideo);
  }

  function syncPlayback() {
    ++generation;
    clearTimeout(timer);
    clearTimeout(prepareTimer);
    if (!canRun()) { video.pause(); return; }
    if (slides[current] === video) {
      if (video.ended) { advance(); return; }
      video.play().then(schedule).catch(advance);
    } else schedule();
  }

  video.addEventListener('ended', () => { if (slides[current] === video) advance(); });
  video.addEventListener('error', () => { if (slides[current] === video) advance(); });
  document.addEventListener('visibilitychange', syncPlayback);
  reducedMotion.addEventListener('change', syncPlayback);
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      const visible = entries[0].isIntersecting;
      if (visible === inView) return;
      inView = visible;
      syncPlayback();
    }, { threshold: 0.01 });
    observer.observe(root.querySelector('.oy-hero'));
  }
  schedule();


})();
(() => {
  const root = document.getElementById('oy-rental-first-piece');
  if (!root) return;
  const section = root.querySelector('.oy-events');
  const track = section.querySelector('.oy-events-track');
  const cards = [...section.querySelectorAll('.oy-event-card')];
  const videos = cards.map(card => card.querySelector('video'));
  const previous = section.querySelector('.oy-event-prev');
  const next = section.querySelector('.oy-event-next');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const media = JSON.parse(document.getElementById('oy-rental-product-media').textContent);
  const thumbUrl = new URL(media[0].src, window.location.href);
  thumbUrl.searchParams.set('width', '80');
  section.querySelectorAll('.oy-event-thumb').forEach(img => { img.src = thumbUrl.href; });
  function preparePoster(video) {
    if (!video.dataset.poster) return;
    const poster = new URL(video.dataset.poster, window.location.href);
    const width = Math.ceil(video.clientWidth * 1.18 * Math.min(window.devicePixelRatio || 1, 2));
    poster.searchParams.set('width', String(Math.min(540, Math.max(270, width))));
    video.poster = poster.href;
    delete video.dataset.poster;
  }
  function prepareVideo(video) {
    preparePoster(video);
    if (!video.dataset.src) return;
    video.src = video.dataset.src;
    delete video.dataset.src;
  }
  if ('IntersectionObserver' in window) {
    const posterObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        preparePoster(entry.target);
        posterObserver.unobserve(entry.target);
      });
    }, {rootMargin: '400px 200px'});
    videos.forEach(video => posterObserver.observe(video));
  } else videos.forEach(preparePoster);
  let active = Math.floor(cards.length / 2);
  let visible = false;
  let initialized = false;
  let manualPause = false;
  let scrollTimer;
  const updateButton = index => {
    const playing = !videos[index].paused;
    cards[index].classList.toggle('oy-event-playing', playing);
    const title = cards[index].querySelector('.oy-event-title').textContent;
    cards[index].querySelector('.oy-event-play').setAttribute('aria-label', `${playing ? root.dataset.pauseLabel : root.dataset.playLabel}: ${title}`);
  };
  function sync() {
    cards.forEach((card, index) => {
      card.classList.toggle('oy-event-active', index === active);
      if (index === active && visible && !document.hidden && !reduced.matches && !manualPause) {
        prepareVideo(videos[index]);
        videos[index].play().catch(() => {});
      } else videos[index].pause();
    });
    previous.disabled = active === 0;
    next.disabled = active === cards.length - 1;
  }
  function center(index, smooth = true) {
    active = Math.max(0, Math.min(cards.length - 1, index));
    manualPause = false;
    sync();
    const card = cards[active];
    track.scrollTo({left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: smooth && !reduced.matches ? 'smooth' : 'auto'});
  }
  previous.addEventListener('click', () => center(active - 1));
  next.addEventListener('click', () => center(active + 1));
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      if (!initialized) return;
      const mid = track.scrollLeft + track.clientWidth / 2;
      const nearest = cards.reduce((best, card, i) => Math.abs(card.offsetLeft + card.offsetWidth / 2 - mid) < Math.abs(cards[best].offsetLeft + cards[best].offsetWidth / 2 - mid) ? i : best, 0);
      if (nearest !== active) { active = nearest; manualPause = false; sync(); }
    }, 120);
  }, {passive: true});
  cards.forEach((card, index) => {
    const video = videos[index];
    video.muted = true;
    const button = card.querySelector('.oy-event-play');
    button.addEventListener('click', () => {
      if (index !== active) center(index);
      else if (!video.paused) { manualPause = true; video.pause(); return; }
      manualPause = false;
      prepareVideo(video);
      video.play().catch(() => {});
    });
    video.addEventListener('play', () => updateButton(index));
    video.addEventListener('pause', () => updateButton(index));
    video.addEventListener('timeupdate', () => {
      card.querySelector('.oy-event-progress span').style.width = `${video.duration ? video.currentTime / video.duration * 100 : 0}%`;
    });
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible && !initialized) { initialized = true; center(active, false); }
      sync();
    }, {threshold: .15});
    observer.observe(track);
  } else {
    visible = true;
    initialized = true;
    center(active, false);
  }
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', sync);
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => { if (initialized) center(active, false); }, 150);
  });
})();


(() => {
  const root = document.getElementById('oy-rental-first-piece');
  if (!root) return;
  const form = root.querySelector('#oy-rental-contact-form');
  const start = form.querySelector('#oy-contact-start');
  const end = form.querySelector('#oy-contact-end');
  const error = form.querySelector('#oy-date-error');
  const messages = form.querySelector('.oy-contact-validation').dataset;
  const submit = form.querySelector('[type="submit"]');
  const localToday = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  };
  function syncDates(fillEnd = false) {
    const today = localToday();
    start.min = today;
    if (fillEnd && start.value && !end.value) end.value = start.value;
    end.min = start.value && start.value >= today ? start.value : today;
    const reversed = Boolean(start.value && end.value && end.value < start.value);
    const pastStart = Boolean(start.value && start.value < today);
    const message = reversed ? messages.dateReversed : '';
    end.setCustomValidity(message);
    start.setAttribute('aria-invalid', String(pastStart));
    end.setAttribute('aria-invalid', String(reversed || Boolean(end.value && end.value < today)));
    error.textContent = pastStart ? messages.datePast : message;
    error.hidden = !error.textContent;
  }
  start.addEventListener('input', () => syncDates(true));
  end.addEventListener('input', () => syncDates());
  start.addEventListener('focus', () => syncDates());
  end.addEventListener('focus', () => syncDates());
  form.addEventListener('submit', event => {
    syncDates();
    if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
  });
  syncDates();
  submit.disabled = false;
})();
